import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listBlog, blogCategories } from "@/lib/api";
import { Reveal } from "@/components/motion/Reveal";
import { ArrowRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [b, c] = await Promise.all([listBlog(active === "All" ? undefined : active), blogCategories()]);
        setPosts(b.posts || []);
        setCats(c.categories || []);
      } finally { setLoading(false); }
    })();
  }, [active]);

  return (
    <main data-testid="blog-page" className="pt-24 md:pt-32 pb-24">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="chapter-index text-emerald-700">Journal · Rightway Notes</p>
        <h1 className="font-display text-5xl md:text-7xl leading-[0.95] mt-3 max-w-3xl">Practical writing on <span className="italic text-emerald-800">borrowing well.</span></h1>

        <div className="mt-10 flex flex-wrap gap-2">
          {["All", ...cats].map((c) => (
            <button key={c} data-testid={`blog-cat-${c}`} onClick={() => { setLoading(true); setActive(c); }} className={`rounded-full px-4 py-2 text-sm transition-colors ${active === c ? 'bg-slate-900 text-white' : 'border border-slate-300 hover:border-slate-900'}`}>{c}</button>
          ))}
        </div>

        {loading ? (
          <p className="mt-12 text-sm text-slate-500">Loading…</p>
        ) : (
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((p) => (
              <Reveal key={p.slug}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block rounded-3xl overflow-hidden bg-white border border-black/[0.06] hover:shadow-2xl hover:shadow-emerald-900/10 transition-all">
                  <div className="aspect-[5/3] overflow-hidden clip-frame">
                    <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[900ms]"/>
                  </div>
                  <div className="p-6">
                    <p className="text-[11px] uppercase tracking-widest text-emerald-700">{p.category} · {p.read_minutes} min read</p>
                    <p className="font-display text-2xl mt-3 text-slate-900 group-hover:text-emerald-800 transition-colors">{p.title}</p>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.excerpt}</p>
                    <p className="mt-4 text-sm inline-flex items-center gap-2 text-slate-700 group-hover:text-emerald-800">Read <ArrowRight size={14}/></p>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </main>
  );
}
